import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Meta from "vue-meta";
import { localize } from "vee-validate";
import pl from "vee-validate/dist/locale/pl.json";
import "@/scss/index.scss";
import Mixin from "./mixins/global-mixin.js";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Vue.mixin(Mixin);

let prod = process.env.NODE_ENV === "production";
Vue.config.productionTip = !prod;
Vue.config.devtools = !prod;
Vue.config.silent = prod;

localize("pl", pl);
localize({
  pl: {
    messages: {
      email: "Niepoprawny format adresu e-mail",
    },
  },
});

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [process.env.VUE_APP_SENTRY_ORIGIN, /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  logErrors: true,
  trackComponents: true,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
});

Sentry.setTag("app", "edb-auth-client");

Vue.use(Meta);
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
